import styled from "@emotion/styled";

export const ArrowWrapper = styled.span`
  display: flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    width: 25px;
    height: 25px;
  }

  transform: ${({ left }) => (left ? "rotate(180deg)" : "none")};
`;
